function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Cash = function Cash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M11.65 3.647V2.09c0-.41.34-.75.75-.75s.75.34.75.75v1.596c2.354.282 4.624 1.865 4.66 4.574 0 .41-.33.75-.74.76-.41 0-.74-.33-.75-.74-.03-2.04-2.04-3.14-3.92-3.14-1.54 0-3.08.12-3.97.97-.79.76-.98 2.03-.42 2.95.69 1.15 2.18 1.65 3.64 2.07l1.57.43c1.52.46 3.18 1.12 4.08 2.61.9 1.51.61 3.58-.67 4.81-.966.926-2.318 1.235-3.48 1.338v1.592c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.54h-.05c-2.6 0-5.38-1.62-5.42-4.62 0-.41.33-.75.74-.76.44-.02.75.33.76.74.03 2.04 2.04 3.14 3.92 3.14 1.54 0 3.08-.12 3.97-.97.79-.76.98-2.03.42-2.95-.63-1.05-1.91-1.55-3.2-1.94l-1.56-.43c-1.68-.48-3.55-1.12-4.52-2.74-.9-1.51-.61-3.58.67-4.81 1.196-1.147 2.984-1.347 4.27-1.383",
    clipRule: "evenodd"
  }));
};
export default Cash;
Cash.displayName = 'Cash';